function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var chatMenuTemplate = require('./chat-manager-menu.template');
var ContactsList = require('./../../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ChatList = require('./chat-list');
var ChatUserMenu = require('./chat-user-menu');
var ChatManagerMenu = /*#__PURE__*/function () {
  function ChatManagerMenu(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, ChatManagerMenu);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.contactList = new ContactsList(app, mod, true);

    //only used if no container provided!
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.chatList = new ChatList(app, mod);
    this.chatList.callback = function (gid) {
      var chatMenu = new ChatUserMenu(_this.app, _this.mod, _this.mod.returnGroup(gid));
      chatMenu.render();
    };
  }
  return _createClass(ChatManagerMenu, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.container) {
                this.overlay.show("<div class=\"module-settings-overlay\"><h2>Chat Settings</h2></div>");
                this.container = '.module-settings-overlay';
              }
              if (document.querySelector('.saito-module-settings')) {
                this.app.browser.replaceElementBySelector(chatMenuTemplate(this.app, this.mod), '.saito-module-settings');
              } else {
                this.app.browser.addElementToSelector(chatMenuTemplate(this.app, this.mod), this.container);
              }
              this.attachEvents();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (document.getElementById('add-publickey')) {
        document.getElementById('add-publickey').onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var add;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return sprompt('Enter Address of Contact to Add:');
                case 1:
                  add = _context2.v;
                  if (add) {
                    if (_this2.app.wallet.isValidPublicKey(add)) {
                      salert("Adding ".concat(add, " as Contact"));
                      _this2.app.keychain.addKey(add);
                      _this2.app.connection.emit('encrypt-key-exchange', add);
                    } else {
                      salert('Not a Network Address / Public Key');
                    }
                  }
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('add-contacts')) {
        document.getElementById('add-contacts').onclick = function (e) {
          _this2.contactList.multi_select = false;
          _this2.contactList.callback = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(person) {
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    if (person) {
                      _this2.app.connection.emit('open-chat-with', {
                        key: person
                      });
                      _this2.overlay.close();
                    }
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }();
          _this2.contactList.render();
        };
      }
      if (document.getElementById('create-group')) {
        document.getElementById('create-group').onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var name, myKeys;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _this2.contactList.multi_select = true;
                  _this2.contactList.title = 'Invite Contacts';
                  _this2.contactList.callback = function (person) {
                    person.push(_this2.mod.publicKey);
                    _this2.mod.sendCreateGroupTransaction(name, person);
                  };
                  _context4.n = 1;
                  return sprompt('Choose a name for the group');
                case 1:
                  name = _context4.v;
                  if (name) {
                    myKeys = _this2.app.keychain.returnKeys();
                    if (myKeys.length > 0) {
                      _this2.contactList.render();
                    } else {
                      _this2.mod.sendCreateGroupTransaction(name);
                    }
                    _this2.overlay.close();
                  }
                case 2:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('edit-contacts')) {
        document.getElementById('edit-contacts').onclick = function (e) {
          _this2.chatList.render();
        };
      }

      /*if (document.getElementById('enable-notifications')) {
      	document
      		.getElementById('enable-notifications')
      		.addEventListener('change', (e) => {
      			if (e.currentTarget.checked) {
      				Notification.requestPermission().then((result) => {
      					if (result === 'granted') {
      						this.mod.enable_notifications = true;
      						siteMessage(
      							'System Notifications granted for Chat Messages',
      							3000
      						);
      					} else {
      						siteMessage(
      							'Error enabling System Notifications',
      							3000
      						);
      					}
      				});
      			} else {
      				this.mod.enable_notifications = false;
      				siteMessage(
      					'System Notifications turned off for Chat Messages',
      					3000
      				);
      			}
      			this.mod.saveOptions();
      		});
      }*/

      var f1 = document.getElementById('sensitivity-fieldset');
      var f2 = document.getElementById('chime-fieldset');
      if (document.getElementById('audio-notifications') && f1 && f2) {
        document.getElementById('audio-notifications').addEventListener('change', function (e) {
          if (e.currentTarget.checked) {
            f1.style.display = 'grid';
            f2.style.display = 'grid';
          } else {
            _this2.mod.audio_notifications = '';
            f1.style.display = 'none';
            f2.style.display = 'none';
            _this2.mod.saveOptions();
          }
        });
      }
      Array.from(document.querySelectorAll("input[name='chime-threshold']")).forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          if (e.currentTarget.value !== _this2.mod.audio_notifications) {
            _this2.mod.audio_notifications = e.currentTarget.value;
            _this2.mod.saveOptions();
          }
        });
      });
      Array.from(document.querySelectorAll("input[name='chat-chime']")).forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          if (e.currentTarget.value !== _this2.mod.audio_chime) {
            _this2.mod.audio_chime = e.currentTarget.value;
            _this2.mod.chime = new Audio("/saito/sound/".concat(_this2.mod.audio_chime, ".mp3"));
            _this2.mod.saveOptions();
          }
        });
      });
      if (document.getElementById('auto-open')) {
        document.getElementById('auto-open').addEventListener('change', function (e) {
          if (e.currentTarget.checked) {
            _this2.mod.auto_open_community = true;
          } else {
            _this2.mod.auto_open_community = false;
          }
          _this2.mod.saveOptions();
        });
      }
      if (document.getElementById('chat-link')) {
        document.getElementById('chat-link').addEventListener('click', function (e) {
          var link = window.location.origin + '/chat?chat_id=' + _this2.mod.publicKey;
          navigator.clipboard.writeText(link);
          siteMessage('Link Copied', 2000);
        });
      }
      if (document.getElementById('blocked-accounts')) {
        document.getElementById('blocked-accounts').onclick = function (e) {
          _this2.contactList.title = 'Blocked Accounts';
          _this2.contactList.multi_button = 'Unblock Selected Accounts';
          _this2.contactList.callback = function (keys) {
            var _iterator = _createForOfIteratorHelper(keys),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var key = _step.value;
                for (var i = _this2.mod.black_list.length; i >= 0; i--) {
                  if (_this2.mod.black_list[i] == key) {
                    _this2.mod.black_list.splice(i, 1);
                    break;
                  }
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _this2.mod.saveOptions();
            _this2.render();
          };
          _this2.contactList.render(_this2.mod.black_list);
        };
      }
      document.querySelectorAll('.sound-preview').forEach(function (sound) {
        sound.onclick = function (e) {
          var chime = e.currentTarget.dataset.id;
          var preview = new Audio("/saito/sound/".concat(chime, ".mp3"));
          preview.play();
        };
      });
    }
  }]);
}();
module.exports = ChatManagerMenu;